export default "__VITE_ASSET__BRf$4qg3__"